import React from "react";
import PropTypes from "prop-types";

const LockOpenButton = props => (
  <button
    type="button"
    className={"btn btn-edit ic-lock-btn " + props.className}
    onClick={props.onClick}
  >
    <i className="fas fa-lock-open" />
  </button>
);

export default LockOpenButton;

LockOpenButton.defaultProps = {
  className: "",
  onClick: () => {}
};

LockOpenButton.prototype = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
